var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeingPacked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 62,
    viewBox: "0 0 99 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Physical Box - Being Packed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.92977 10.3864H90.6012C95.0469 10.3864 98.6501 13.9895 98.6501 18.4352V53.8035C98.6501 58.2491 95.0469 61.8523 90.6012 61.8523H8.92977C4.48408 61.8523 0.880926 58.2491 0.880926 53.8035V18.4352C0.863 13.9895 4.48408 10.3864 8.92977 10.3864Z",
    fill: "#F77D55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.9088 28.9578L18.0361 38.4228L18.3767 61.8522H49.5144H80.6163L81.4947 39.1936L49.9088 28.9578Z",
    fill: "#775442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.5861 50.0032L49.4606 61.8523H18.3767L18.0361 38.4229L28.0748 42.0977L35.299 44.7508L49.5861 50.0032Z",
    fill: "#E2995E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.4945 39.1936L80.6161 61.8522H49.4604L49.5859 50.0031L49.6576 49.9672L81.4945 39.1936Z",
    fill: "#BB8453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.9873 46.5792L41.9675 58.9304L49.5862 50.0032L18.0182 38.4229L9.9873 46.5792ZM81.4947 39.1937L49.6578 50.0032L57.2764 58.9304L89.2567 46.5792L81.4947 39.1937Z",
    fill: "#EFB37D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M56.0755 24.8886V29.5315H65.9707V24.8886H56.0755ZM32.3413 29.5315H42.2366V24.8886H32.3413V29.5315ZM58.7465 2.08655H39.5476V6.7294H58.7465V2.08655Z",
    fill: "#008577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.10107 35.3216L20.4202 34.0489L7.6747 29.9438L7.10107 35.3216ZM11.4033 23.1856L21.7288 31.7185L15.6339 19.7976L11.4033 23.1856ZM24.2922 30.9656L28.3973 18.2201L23.0195 17.6285L24.2922 30.9656ZM89.1669 29.9438L76.4214 34.0489L89.7406 35.3216L89.1669 29.9438ZM81.2436 19.7976L75.1487 31.7185L85.4741 23.1856L81.2436 19.7976ZM72.5673 30.9656L73.8401 17.6465L68.4622 18.2381L72.5673 30.9656Z",
    fill: "#FCF4F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M56.0755 29.5315H65.9707L49.156 45.3244L32.3413 29.5315H42.2366L39.5476 6.72937H58.7465L56.0755 29.5315Z",
    fill: "#07A69C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeingPacked);
export default __webpack_public_path__ + "static/media/being_packed.cdfef1fbc008ed9f19fbe04771a76a18.svg";
export { ForwardRef as ReactComponent };